import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiPost } from '@/lib/http/client';
import {
  portfolioQueryKeys,
  portfolioResendInvitationUrl,
} from '@/lib/portfolio/api';

interface ResendInvitationParams {
  invitationId: string;
}

export function useResendInvitation(portfolioId: number, orgId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ invitationId }: ResendInvitationParams) =>
      apiPost(
        portfolioResendInvitationUrl(portfolioId, orgId, invitationId),
        {}
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: portfolioQueryKeys.orgInvitations(portfolioId, orgId),
      });
    },
  });
}
